import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import './FAQ.scss';

export default function FAQ() {
  const { t } = useI18n();
  const items = t('videoGeneration.wan.faq.items');
  return (
    <section className="wan-faq">
      <div className="wan-faq__inner">
        <h2>{t('videoGeneration.wan.faq.title')}</h2>
        <p className="wan-faq__sub">{t('videoGeneration.wan.faq.sub')}</p>

        <div className="wan-faq__list">
          {items.map((item) => (
            <div key={item.num} className="wan-faq__item">
              <div className="wan-faq__num">{item.num}</div>
              <div className="wan-faq__content">
                <h3>{item.q}</h3>
                <p>{item.a}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="wan-faq__cta">
          <button
            type="button"
            className="wan-faq__link"
          >
            {t('videoGeneration.wan.faq.cta')}
            <span>{t('videoGeneration.wan.faq.contact')}</span>
          </button>
        </div>
      </div>
    </section>
  );
}
